import React, { FC } from 'react';
import translate from '@translate';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { ExportTypeType } from 'src/types/table';
import ExportTableAction from 'src/components/ExportTableAction';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { TABS } from '../AllOrdersContainer/constants';
import { useNavigate } from 'react-router-dom';
import { AddIcon } from 'src/components/SkladonIcon/Icons';
import { getTabs } from '../AllOrdersContainer/functions';

type TopBlockProps = {
    handleExport: (type: ExportTypeType) => void;
    reloadTableData: () => void;
    permissionCreate?: boolean;
};

const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();

    const handleChange = (newUrl: string) => {
        navigate('/orders/' + newUrl);
    };

    const handleNew = () => {
        navigate(`/orders/messages_on_expedition_box/new/`);
    };

    return (
        <BodyTopBlock
            tabs={getTabs()}
            selectTab={'messages_on_expedition_box'}
            onChangeTab={handleChange}
            actions={[
                {
                    node: (
                        <ExportTableAction
                            title={translate('orderMessagesOnExpeditionBox.action.exportFile')}
                            handleExport={props.handleExport}
                        />
                    ),
                },
                {
                    onClick: () => props.reloadTableData(),
                    icon: <AutorenewIcon />,
                    tooltip: translate('orderMessagesOnExpeditionBox.action.synchronizeTable'),
                    variant: 'outlined',
                },
                {
                    label: translate('orderMessagesOnExpeditionBox.action.createNew'),
                    onClick: handleNew,
                    icon: <AddIcon />,
                    hidden: !props.permissionCreate,
                },
            ]}
        />
    );
};

export default TopBlock;
